import React, { useState } from 'react';
import { VectorLayerPanel } from '@meitu/saas-editor-ui/es/panels/vector-layer';
import { usePanelLayerId } from '@/hooks/use-panel-layer-id';
import { editor } from '@/instance';
import { isIntl } from '@/react-process-env';
import { useFontMaterialModel } from '@/store/models/font-material-model';
import { useRecordModel } from '@/store/models/record-model';
import { useUserInfoModel } from '@/store/models/user-info-model';
import { openVipModal } from '@/utils/login';
import './vector-panel.less';
import { Tabs } from '@meitu/saas-ui';
import { isEditAIPPTComponent, isEditAIPPTTemplate } from '@/hooks/fetch-template/editor-mode';
import PPTMarkPanel from '../ppt-mark-panel';

const pptMarkTabsList = [
    {
        name: '画笔',
        tabKey: 'bg',
    },
    {
        name: 'ppt打标',
        tabKey: 'pptMark',
    },
];

const RenderTabs: React.FC<{
    showMaskContent: boolean;
    setShowMaskContent: (flag: boolean) => void;
    isPPT?: boolean;
}> = ({ isPPT = false, setShowMaskContent }) => {
    const [tabIndex, setTabIndex] = useState(1);
    const handleTabClick = (key: string) => {
        setTabIndex(key === 'bg' ? 1 : 2);
        setShowMaskContent(key !== 'bg');
    };

    return (
        <div style={{ padding: '0 var(--gap-lg)' }}>
            <Tabs
                showContent={false}
                data={isPPT ? pptMarkTabsList : []}
                tabsWidth="228px"
                tabsHeight="34px"
                handleTabClick={handleTabClick}
                activeIndex={tabIndex}
            />
        </div>
    );
};

const isAIPPTMark = isEditAIPPTComponent() || isEditAIPPTTemplate();

const VectorPanel: React.FC = () => {
    const layerId = usePanelLayerId();

    const fonts = useFontMaterialModel((state) => state.fonts);
    const recordInfo = useRecordModel((state) => state.recordInfo);
    const isVipUser = useUserInfoModel((state) => state.userInfo?.is_vip ?? false);
    const listStyles = useFontMaterialModel((state) => state.listStyles);
    const [showMaskContent, setShowMaskContent] = useState(false);

    if (!layerId) return null;
    return (
        <div>
            {isAIPPTMark ? (
                <div style={{ marginTop: '16px' }}>
                    <RenderTabs
                        showMaskContent={showMaskContent}
                        setShowMaskContent={setShowMaskContent}
                        isPPT={isAIPPTMark}
                    />
                </div>
            ) : null}

            <div
                style={{
                    display: `${isAIPPTMark && showMaskContent ? 'none' : 'block'}`,
                }}
            >
                <VectorLayerPanel
                    isIntl={isIntl}
                    recordId={recordInfo?.id}
                    fonts={editor.services.font.toFontItems(fonts)}
                    listStyles={listStyles.filter((item) => item.type === 'char')}
                    editor={editor}
                    layerId={layerId}
                    isVIP={isVipUser}
                    onOpenVIPModal={openVipModal}
                    enableRemoteSearch={false}
                />
            </div>

            {isAIPPTMark && showMaskContent ? <PPTMarkPanel editor={editor} key={layerId} /> : null}
        </div>
    );
};

export default React.memo(VectorPanel);
